import type { VoidFunctionComponent } from 'react';

import { emptyConclusionData } from '../../../../../../shared/types/licenses';
import useGetReleaseGroupDependency from '../../../../../hooks/api/dependencies/useGetReleaseGroupDependency';
import DependencyLicenses from '../../../../projects/dependenciesV2/DependencyDrawer/content/DependencyLicenses/DependencyLicenses';
import type {
  LicenseTabScope,
} from '../../../../projects/dependenciesV2/DependencyDrawer/content/DependencyLicenses/types';

type ReleaseGroupLicensesTableProps = {
  dependencyRevisionLocator: string;
  releaseGroupId: number;
  releaseId: number;
};

export const ReleaseGroupLicensesTable: VoidFunctionComponent<ReleaseGroupLicensesTableProps> = ({
  dependencyRevisionLocator,
  releaseGroupId,
  releaseId,
}) => {
  const { data, isLoading } = useGetReleaseGroupDependency(
    releaseGroupId,
    releaseId,
    dependencyRevisionLocator,
    true,
  );

  const licenseTabScope: LicenseTabScope = {
    dependencyRevisionLocator,
    type: 'releaseGroup',
    releaseGroupId,
    releaseId,
  };

  const dependency = data?.dependency;

  return (
    <DependencyLicenses
      issues={dependency?.issues || []}
      licenseGroups={dependency?.licenseGroups || []}
      concludedLicenses={dependency?.conclusions || emptyConclusionData}
      scope={licenseTabScope}
      isLoading={isLoading}
      dependency={{
        title: dependency?.title || '',
        version: dependency?.version || '',
        locator: dependency?.locator || '',
      }}
      shouldAllowEditing
    />
  );
};
